// extracted by mini-css-extract-plugin
module.exports = {"card":"user-card_card__2Czwn","cardBody":"user-card_cardBody__1kBFx","cardImage":"user-card_cardImage__3bm8j"};